import useActiveState from "../../lib/useActiveState";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useThrottleEffect, useLocalStorageState } from "ahooks";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Autoplay]);

// 首页顶部搜索框
export default (props) => {
  const [messages, setMessages] = useActiveState("index-messages");
  useThrottleEffect(
    () => {
      if (props.active && general.isLogin()) {
        general.axios
          .post("/v3/getUnReadWarn")
          .then(({ data: resData }) => {
            let { status, data } = resData;
            if (!status.succeed) {
              Dialog.error(status.error_desc);
              return null;
            }
            setMessages(data.unread_warn == 1);
          })
          .catch((error) => console.error(error.message));
      }
    },
    [props.active],
    { wait: 500 }
  );

  let [kws, setKws] = useLocalStorageState("search-kws", {
    defaultValue: [],
  });
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    general.axios
      .get("/v3/base/search/index", {
        headers: { username: "" },
      })
      .then((res) => {
        let { status, data } = res.data;
        console.log("搜索页数据", data);
        if (!status.succeed) {
          return;
        }
        kws = data.search_keyword;
        setKws(data.search_keyword);
        setDataLoaded(true);
      })
      .catch((err) => {
        console.log("search " + err.message);
        // 即使请求失败，也设置数据已加载，使用默认值
        setDataLoaded(true);
      });
  }, []);

  return (
    <div className="classify-head-content">
      <div className="status-bar-background"></div>

      <Link to="/search" className="search">
        <img className="search-img" src="/resources/common/search.png" alt="" />

        {dataLoaded && kws.length > 0 ? (
          <div className="search-index-input-main">
            <div className="search-index-input-main-swiper">
              <Swiper
                key="index-head-new"
                autoplay={{
                  delay: 3000,
                }}
                loop={true}
                direction="vertical"
              >
                {kws.map((item, index) => (
                  <SwiperSlide
                    key={index}
                    className="search-index-input-main-swiper-slide"
                  >
                    <div className="search-index-input-main-swiper-slide-text">
                      {item}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        ) : (
          <span>搜一搜</span>
        )}
      </Link>
    </div>
  );
};
